import React from 'react'
import {objectLang, setLocalStorageItem} from "../functions"
import {GoogleLoginButton} from "../GoogleLoginButton"
// import {FacebookLoginButton} from "../FacebookLoginButton"
import {YandexLoginButton} from "../YandexLoginButton"
import {MailLoginButton} from "../MailLoginButton"
import {EnterDataButton} from "../EnterDataButton"

export const RegisterPageSocial = () => {
    setLocalStorageItem('page', 'RegisterPageSocial')
    let lang = objectLang().language

    let widthWinSocial = '600px'
    if (window.matchMedia('(max-width: 768px)').matches) {
        widthWinSocial = window.innerWidth
    }

    // reloadOnceWithoutCache()
    return (
        <>
            <div className={'pt-3 d-flex flex-wrap justify-content-center'}>
                <div className={'d-flex w-100 justify-content-center'}>
                    <h1 className={'mb-4 text-center fw-bold'}>{lang.body.registerPage.title}</h1>
                </div>
                <div id={'buttons-social'} style={{width: widthWinSocial}}>
                    <div
                        className={'social mt-1 m-3 mb-3 pt-0 p-3 border border-dark-subtle border-opacity-25 rounded-3'}>
                        <EnterDataButton disabled={false} isRegistration={true} isLogin={false}/>
                        <GoogleLoginButton disabled={false} isRegistration={true} isLogin={false}/>
                        {/*<FacebookLoginButton disabled={true} isRegistration={true} isLogin={false}/>*/}
                        <YandexLoginButton disabled={true} isRegistration={true} isLogin={false}/>
                        <MailLoginButton disabled={true} isRegistration={true} isLogin={false}/>
                    </div>
                </div>
            </div>
        </>
    )
}
